import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Products from '../views/Products.vue'
import Discount from '../views/Discount.vue'
import SocioComercial from '../views/SocioComercial'
import Register from '../views/Register'
import ClienteConciliaDetalleCliente from '../views/Client/ClienteConciliaDetalleCliente'
import ProductDetalleCliente from '../views/Client/ProductDetalleCliente'
import PasswordRecovery from '../views/Auth/PasswordRecovery'
import ClientAddBranchOffice from '../views/Client/AddBranchOffice'
import ClientShowBranchOffice from '../views/Client/ShowBranchOffice'
import ClientAddProduct from '../views/Client/AddProduct.vue'
import ShowIncidenceAdmin from '../views/Admin/ShowIncidenceAdmin'

import ClientShowProduct from '../views/Client/ShowProduct.vue'
import ClientAddDiscount from '../views/Client/AddDiscount.vue'
import ShowDiscount from '../views/Client/ShowDiscount.vue'

import ClientShowDiscount from '../views/Client/ShowDiscount.vue'
import CPPProducts from '../views/Client/ConciliacionOperativa/Productos'
import CPCClients from '../views/Client/ConciliacionOperativa/Clientes'
import CPBBolette from '../views/Client/ConciliacionOperativa/Boletas'
import ICContable from '../views/Client/Incidencias/Contable'
import ICOpeerativoContable from '../views/Client/Incidencias/OperativoContable'
import IDClientes from '../views/Client/Indicadores/Clientes'
import IDProductos from '../views/Client/Indicadores/Productos'
import IDSucursales from '../views/Client/Indicadores/Sucursales'
import IDVentas from '../views/Client/Indicadores/Ventas'
import IDMapaValidacion from '../views/Client/Indicadores/MapaValidacion'
import ProductsAdmin from '../views/ProductsAdmin'
import IncidenciaAdmin from '../views/IncidenciaAdmin'
import IncidenciaAdminDetaller from '../views/Admin/ShowIncidence'
import BuzonSugerenciaAdminDetalle from '../views/Admin/ShowBuzonSugerencias'
import ShowOperativoContable from '../views/ShowOperativoContable'
import Incidencias from '../views/Incidencias'
import BuzonSugerencias from '../views/BuzonSugerencias'
import IndicatorsProducts from '../views/IndicatorsProducts'
import Indicatorscustomers from '../views/Indicatorscustomers'
import IndicatorsSales from '../views/IndicatorsSales'
import IndicatorsB2C from '../views/IndicatorsB2C'
import ClientesB2C from '../views/Admin/ClientesB2C'
import EditUsuariosB2C from '../views/Admin/EditUsuariosB2C'
import ClientesB2B from '../views/Admin/ClientesB2B'
import B2B from '../views/Admin/B2B'
import UsuariosB2B from '../views/Admin/UsuariosB2B'
import UsuariosB2C from '../views/Admin/UsuariosB2C'
import CargaArchivos from '../views/Admin/CargaArchivos'
import ConciliacionActiva from '../views/Admin/ConciliacionActiva'
import ConciliacionContable from '../views/Admin/ConciliacionContable'
import AdminAddUserB2B from '../views/Admin/AdminAddUserB2B'
import AdminAddUserB2C from '../views/Admin/AdminAddUserB2C'
import AdminAddClientB2C from '../views/Admin/AdminAddClientB2C'
import AddAdminUserB2B from '../views/Admin/AddAdminUserB2B'
import AddClientB2B from '../views/AddClientB2B'
import AddUsuarioB2B from '../views/AddUsuarioB2B'
import TermsConditions from '../views/TermsConditions'
import PrivacyPolicy from '../views/PrivacyPolicy'
import ValidatingUsers from '../views/Client/ValidatingUsers/ValidatingUsers'
import AddValidatingUsers from '../views/Client/ValidatingUsers/AddValidatingUsers';
import UpdateValidatingUsers from '../views/Client/ValidatingUsers/UpdateValidatingUsers';
import Mesas from '../views/Mesas.vue'
import ClientAddMesa from '../views/Client/AddMesa.vue'
import ClientShowMesa from '../views/Client/ShowMesa.vue'
import MenuMesas from '../views/MenuMesas.vue'
import ClientAddMenuMesas from '../views/Client/AddMenuMesas.vue'
import ClientShowMenuMesas from '../views/Client/ShowMenuMesas.vue'
import PosMesas from '../views/PosMesas.vue'
import PosDashboard from '../views/PosDashboard.vue'
import PosApiTest from '../views/PosApiTest.vue'
import PosComprobantes from '../views/PosComprobantes.vue'
import Configuracion from '../views/Configuracion.vue'
import FacturacionElectronica from '../views/Client/FacturacionElectronica.vue'



const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/products',
    name: 'Products',
    component: Products
  },
  {
    path: '/discount',
    name: 'Discount',
    component: Discount
  },
  {
    path: '/mesas',
    name: 'Mesas',
    component: Mesas
  },
  {
    path: '/ProductsAdmin',
    name: 'ProductsAdmin',
    component: ProductsAdmin
  },
  {
    path: '/ClienteConciliaDetalleCliente',
    name: 'ClienteConciliaDetalleCliente',
    component: ClienteConciliaDetalleCliente
  },
  {
    path: '/ProductDetalleCliente',
    name: 'ProductDetalleCliente',
    component: ProductDetalleCliente
  },
  {
    path: '/AddAdminUserB2B',
    name: 'AddAdminUserB2B',
    component: AddAdminUserB2B
  },
  {
    path: '/AdminAddUserB2B',
    name: 'AdminAddUserB2B',
    component: AdminAddUserB2B
  },
  {
    path: '/ShowIncidenceAdmin',
    name: 'ShowIncidenceAdmin',
    component: ShowIncidenceAdmin
  },
  {
    path: '/AdminAddUserB2C',
    name: 'AdminAddUserB2C',
    component: AdminAddUserB2C
  },
  {
    path: '/AdminAddClientB2C',
    name: 'AdminAddClientB2C',
    component: AdminAddClientB2C
  },
  {
    path: '/IncidenciaAdmin',
    name: 'IncidenciaAdmin',
    component: IncidenciaAdmin
  },
  {
    path: '/Incidencias',
    name: 'Incidencias',
    component: Incidencias
  },
  {
    path: '/B2B',
    name: 'B2B',
    component: B2B
  },
  {
    path: '/ClientesB2B',
    name: 'ClientesB2B',
    component: ClientesB2B
  },
  {
    path: '/ClientesB2B/AddClientB2B',
    name: 'AddClientB2B',
    component: AddClientB2B
  },
  {
    path: '/UsuariosB2B/AddUsuarioB2B',
    name: 'AddUsuarioB2B',
    component: AddUsuarioB2B
  },
  {
    path: '/ClientesB2C',
    name: 'ClientesB2C',
    component: ClientesB2C
  },
  // {
  //   path: '/ClientesB2C',
  //   name: 'ClientesB2C',
  //   component: UsuariosB2C
  // },
  {
    path: '/UsuariosB2C',
    name: 'UsuariosB2C',
    component: UsuariosB2C
  },
  {
    path: '/EditUsuariosB2C',
    name: 'EditUsuariosB2C',
    component: EditUsuariosB2C
  },
  {
    path: '/UsuariosB2B',
    name: 'UsuariosB2B',
    component: UsuariosB2B
  },
  {
    path: '/InboxSugerences',
    name: 'BuzonSugerencias',
    component: BuzonSugerencias
  },
  {
    path: '/CargaArchivos',
    name: 'CargaArchivos',
    component: CargaArchivos
  },
  {
    path: '/ConciliacionActiva',
    name: 'ConciliacionActiva',
    component: ConciliacionActiva
  },
  {
    path: '/ConciliacionContable',
    name: 'ConciliacionContable',
    component: ConciliacionContable
  },
  {
    path: '/Indicators/productos',
    name: 'IndicatorsProducts',
    component: IndicatorsProducts
  },
  {
    path: '/Indicators/customers',
    name: 'Indicatorscustomers',
    component: Indicatorscustomers
  },
  {
    path: '/Indicators/sales',
    name: 'IndicatorsSales',
    component: IndicatorsSales
  },
  {
    path: '/Indicators/B2C',
    name: 'IndicatorsB2C',
    component: IndicatorsB2C
  },
  {
    path: '/comercial',
    name: 'SocioComercial',
    component: SocioComercial
  },

  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/passwordrecovery',
    name: 'PasswordRecovery',
    component: PasswordRecovery
  },
  {
    path: '/Client/addbranchoffice',
    name: 'ClientAddBranchOffice',
    component: ClientAddBranchOffice
  },
  {
    path: '/Client/showbranchoffice',
    name: 'ClientShowBranchOffice',
    component: ClientShowBranchOffice
  },

  {
    path: '/IncidenciaAdminDetaller',
    name: 'IncidenciaAdminDetaller',
    component: IncidenciaAdminDetaller
  },
  {
    path: '/BuzonSugerenciaAdminDetalle',
    name: 'BuzonSugerenciaAdminDetalle',
    component: BuzonSugerenciaAdminDetalle
  },
  {
    path: '/ShowOperativoContable',
    name: 'ShowOperativoContable',
    component: ShowOperativoContable
  },
  {
    path: '/Client/addproduct',
    name: 'ClientAddProduct',
    component: ClientAddProduct
  },
  {
    path: '/Client/showproduct',
    name: 'ClientShowProduct',
    component: ClientShowProduct
  },
  {
    path: '/Client/adddiscount',
    name: 'ClientAddDiscount',
    component: ClientAddDiscount
  },
  {
    path: '/Client/ShowDiscount',
    name: 'ShowDiscount',
    component: ShowDiscount
  },
  {
    path: '/Client/showdiscount',
    name: 'ClientShowDiscount',
    component: ClientShowDiscount
  },
  {
    path: '/Client/cp-productos',
    name: 'CPProductos',
    component: CPPProducts
  },
  {
    path: '/Client/cp-clientes',
    name: 'CPCClients',
    component: CPCClients
  },
  {
    path: '/Client/cp-boletas',
    name: 'CPBBolette',
    component: CPBBolette
  },
  {
    path: '/Client/ic-contable',
    name: 'ICContable',
    component: ICContable
  },
  {
    path: '/Client/ic-operativo-contable',
    name: 'ICOpeerativoContable',
    component: ICOpeerativoContable
  },
  {
    path: '/Client/id-clientes',
    name: 'IDClientes',
    component: IDClientes
  },
  {
    path: '/Client/id-productos',
    name: 'IDProductos',
    component: IDProductos
  },
  {
    path: '/Client/id-sucursales',
    name: 'IDSucursales',
    component: IDSucursales
  },
  {
    path: '/Client/id-ventas',
    name: 'IDVentas',
    component: IDVentas
  },
  {
    path: '/Client/id-mapa-validacion',
    name: 'IDMapaValidacion',
    component: IDMapaValidacion
  },
  {
      path: '/terminos-condiciones',
      name: 'TermsConditions',
      component: TermsConditions
  },
  {
    path: '/politicas-privacidad',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/usuarios-validadores',
    name: 'ValidatingUsers',
    component: ValidatingUsers
  }
  ,
  {
    path: '/crear-usuarios-validadores',
    name: 'AddValidatingUsers',
    component: AddValidatingUsers
  },
  {
    path: '/editar-usuarios-validadores',
    name: 'UpdateValidatingUsers',
    component: UpdateValidatingUsers
  },
  {
    path: '/Client/addmesa',
    name: 'ClientAddMesa',
    component: ClientAddMesa
  },
  {
    path: '/Client/showmesa',
    name: 'ClientShowMesa',
    component: ClientShowMesa
  },
  {
    path: '/menu-mesas',
    name: 'MenuMesas',
    component: MenuMesas
  },
  {
    path: '/Client/addmenumesas',
    name: 'ClientAddMenuMesas',
    component: ClientAddMenuMesas
  },
  {
    path: '/Client/showmenumesas',
    name: 'ClientShowMenuMesas',
    component: ClientShowMenuMesas
  },
  {
    path: '/pos-mesas',
    name: 'PosMesas',
    component: PosMesas
  },
  {
    path: '/pos-resumen',
    name: 'PosDashboard',
    component: PosDashboard
  },
  {
    path: '/pos-comprobantes',
    name: 'PosComprobantes',
    component: PosComprobantes
  },
  {
    path: '/pos-api-test',
    name: 'PosApiTest',
    component: PosApiTest
  },
  {
    path: '/configuracion',
    name: 'Configuracion',
    component: Configuracion
  },
  {
    path: '/facturacion-electronica',
    name: 'FacturacionElectronica',
    component: FacturacionElectronica
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
